import { render, staticRenderFns } from "./FormMDM.vue?vue&type=template&id=10ce1d66&"
import script from "./FormMDM.vue?vue&type=script&lang=js&"
export * from "./FormMDM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports